function makeStory(id, title, count) {
    return {
        _id: id,
        title,
        totalArticleCount: count,
        articleCount: count,
        groupSubject: { _id: id, title, slug: id, articleCount: count },
        languagesCodes: ['en'],
        articles: [],
        earliest: new Date().toISOString(),
        recent: new Date().toISOString(),
    };
}

const FIXTURE_STORIES = [
    makeStory('fix-story-1', 'International Energy Agency and 32 Countries Agree to Release 400 Million Barrels of Oil from Strategic Reserves to Stabilize Market Prices Amidst Supply Disruption and Iran Conflict', 12),
    makeStory('fix-story-2', 'President Trump Signals Swift End to US Military Operations Against Iran, Stating Little Remains to Target', 8),
    makeStory('fix-story-3', 'Iran Warns of $300 Oil Price Spike Amid Escalating Gulf Shipping Attacks and Threats to Strait of Hormuz', 15),
    makeStory('fix-story-4', 'Iran Withdraws from 2038 FIFA World Cup Following US-Led Airstrikes That Killed Supreme Leader, Citing War with US and Israel', 6),
    makeStory('fix-story-5', 'International Energy Agency Coordinates Largest Ever Joint Oil Reserve Release to Stabilize Markets and Lower Prices Amidst Middle East Conflict', 10),
    makeStory('fix-story-6', 'Drones Strike Fuel Tanks at Oman\'s Salalah Port, Causing Large Fire; No Casualties Reported', 4),
];

const FIXTURE_STORY = {
    _id: 'fix-story-1',
    title: 'Tech Giants Found Liable for Social Media Addiction Harm in Landmark Lawsuit Awarding Millions to Victim',
    slug: 'fix-story-1',
    totalArticleCount: 8,
    articleCount: 8,
};

const FIXTURE_ARTICLES = [
    {
        _id: 'fix-art-1',
        title: 'Jury rules in favor of young woman accusing Meta and YouTube of social media addiction',
        url: 'https://example.com/article-1',
        source: { title: 'BBC News', uri: 'bbc.com' },
        sources: [{ title: 'BBC News', uri: 'bbc.com' }],
        lang: 'eng',
        language: 'English',
        dateTimePub: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
        isSelected: true,
        isPreferredPublisher: true,
    },
    {
        _id: 'fix-art-2',
        title: 'Woman awarded $6 million in social media addiction case against Meta and Google',
        url: 'https://example.com/article-2',
        source: { title: 'BBC News', uri: 'bbc.com' },
        sources: [{ title: 'BBC News', uri: 'bbc.com' }],
        lang: 'eng',
        language: 'English',
        dateTimePub: new Date(Date.now() - 8 * 60 * 60 * 1000).toISOString(),
        isSelected: true,
        isPreferredPublisher: true,
    },
    {
        _id: 'fix-art-3',
        title: 'Meta and YouTube found negligent in landmark social media addiction trial',
        url: 'https://example.com/article-3',
        source: { title: 'Reuters', uri: 'reuters.com' },
        sources: [{ title: 'Reuters', uri: 'reuters.com' }],
        lang: 'eng',
        language: 'English',
        dateTimePub: new Date(Date.now() - 8 * 60 * 60 * 1000).toISOString(),
        isSelected: true,
        isPreferredPublisher: true,
    },
    {
        _id: 'fix-art-4',
        title: 'Meta and Google Found Liable for Social Media Addiction Harm to Young Woman',
        url: 'https://example.com/article-4',
        source: { title: 'Bloomberg', uri: 'bloomberg.com' },
        sources: [{ title: 'Bloomberg', uri: 'bloomberg.com' }],
        lang: 'eng',
        language: 'English',
        dateTimePub: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(),
        isSelected: true,
        isPreferredPublisher: true,
    },
    {
        _id: 'fix-art-5',
        title: 'Meta and Google found liable for social media addiction',
        url: 'https://example.com/article-5',
        source: { title: 'BBC News', uri: 'bbc.com' },
        sources: [{ title: 'BBC News', uri: 'bbc.com' }],
        lang: 'eng',
        language: 'English',
        dateTimePub: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(),
        isSelected: true,
        isPreferredPublisher: true,
    },
    {
        _id: 'fix-art-5b',
        title: 'Meta and YouTube found liable for addicting a young user, jury awards $3 million',
        url: 'https://example.com/article-5b',
        source: { title: 'The New York Times', uri: 'nytimes.com' },
        sources: [{ title: 'The New York Times', uri: 'nytimes.com' }],
        lang: 'fra',
        language: 'French',
        dateTimePub: new Date(Date.now() - 13 * 60 * 60 * 1000).toISOString(),
        isSelected: true,
        isPreferredPublisher: false,
    },
];

function claimSource(title) {
    return { title, uri: 'example.com', articleId: 'fix-art-1', source: { title } };
}

const FIXTURE_CLAIMS = [
    {
        _id: 'fix-claim-1',
        text: 'This verdict is historic and landmark, potentially setting a precedent for hundreds of similar cases alleging tech companies should be held accountable for harmful design decisions.',
        claim: 'This verdict is historic and landmark, potentially setting a precedent for hundreds of similar cases alleging tech companies should be held accountable for harmful design decisions.',
        title: 'Historic verdict sets precedent',
        sources: [
            claimSource('Portafolio'), claimSource('Portafolio'), claimSource('Portafolio'),
            claimSource('Blog'), claimSource('Semotus'), claimSource('Chosun Ilbo'),
            claimSource('Psychology Today'), claimSource('N-tv'), claimSource('The Age'),
        ],
        articleCount: 9,
        isSelected: true,
    },
    {
        _id: 'fix-claim-2',
        text: 'A 20-year-old woman, identified as Kayley O.M. (or K.O.M.), filed a lawsuit alleging she became addicted to Instagram and YouTube during her childhood, starting at ages six and nine respectively.',
        claim: 'A 20-year-old woman, identified as Kayley O.M. (or K.O.M.), filed a lawsuit alleging she became addicted to Instagram and YouTube during her childhood, starting at ages six and nine respectively.',
        title: 'Woman files addiction lawsuit',
        sources: [
            claimSource('The new york times'), claimSource('The new york times'),
            claimSource('The new york times'), claimSource('The new york times'),
            claimSource('The new york times'), claimSource('The new york times'),
            claimSource('Bbc news'), claimSource('Portafolio'), claimSource('Portafolio'),
            claimSource('Portafolio'), claimSource('Portafolio'), claimSource('Blog'),
            claimSource('Sina'), claimSource('Somalac'), claimSource('Chosun Ilbo'),
        ],
        articleCount: 8,
        isSelected: true,
    },
    {
        _id: 'fix-claim-3',
        text: 'On March 25th, a jury in California ordered Meta and Google, the parent companies of Instagram and YouTube respectively, to pay Kayley $3 million in personal damages.',
        claim: 'On March 25th, a jury in California ordered Meta and Google, the parent companies of Instagram and YouTube respectively, to pay Kayley $3 million in personal damages.',
        title: 'Jury orders $3 million payment',
        sources: [
            claimSource('Balkanweb'), claimSource('Semotus'),
        ],
        articleCount: 3,
        isSelected: true,
    },
    {
        _id: 'fix-claim-4',
        text: 'A jury awarded the plaintiff $3 million in compensatory damages, finding Meta and Google acted with malice, oppression, or fraud.',
        claim: 'A jury awarded the plaintiff $3 million in compensatory damages, finding Meta and Google acted with malice, oppression, or fraud.',
        title: 'Compensatory damages awarded',
        sources: [
            claimSource('Chosun Ilbo'),
        ],
        articleCount: 1,
        isSelected: true,
    },
];

const FIXTURE_BRIEF = {
    titles: [
        '<p>Jury says Meta and YouTube must pay for mental health harms</p>',
        '<p>Verdict holds Meta and Google responsible over social media harm claims</p>',
        '<p>Jurors rule against Meta and YouTube in first-of-its-kind case on mental well-being</p>',
        '<p>Meta and Google face damages after jury decision in social media harm suit</p>',
        '<p>Courtroom setback for Meta and YouTube as jurors side with plaintiffs over mental health impact</p>',
        '<p>Jury finds Meta and Google liable for psychological harm in landmark trial</p>',
    ],
    header: '<p>Jury says Meta and YouTube must pay for mental health harms</p>',
    subheader: '<p>BBC says jurors ruled that Meta YouTube must compensate for psychological harm to users</p>',
    brief: '<p>A California jury found Meta and Google liable for negligently designing addictive social media platforms that harmed a young user and failing to adequately warn about the dangers, awarding $3 million in compensation damages and assigning 70% responsibility to Meta and 30% to Google. With punitive damages to be determined in a separate hearing, according to Bloomberg. Jurors also concluded the companies acted with malice, oppression, or fraud, a finding that triggers a subsequent phase to decide punishment, according to The New York Times. In a parallel account, an additional $3 million in punitive damages was ordered, with Meta responsible for 70% and Google 30%, according to Peoples Daily.</p>',
};

export function isDesignFixtureMode() {
    if (typeof window === 'undefined') return false;
    const params = new URLSearchParams(window.location.search);
    return params.get('designFixture') === '1';
}

export function getDesignFixtureStep() {
    if (typeof window === 'undefined') return null;
    const params = new URLSearchParams(window.location.search);
    const step = params.get('designStep');
    return step !== null ? parseInt(step, 10) : null;
}

export { FIXTURE_STORIES, FIXTURE_STORY, FIXTURE_ARTICLES, FIXTURE_CLAIMS, FIXTURE_BRIEF };
